import { useEffect, useState } from 'react';
import Cropper from "react-easy-crop";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import CropIcon from '@mui/icons-material/Crop';

const WIDTH = 700
const HEIGHT = 450
const DEFAULT_ZOOM = 0.96

function CropModal({ open, imageSrc, onCancel, onComplete }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState(DEFAULT_ZOOM)
  const [preview, setPreview] = useState('')
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropComplete = (_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const createImage = (url) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = url;
      img.onload = () => resolve(img);
      img.onerror = (error) => reject(error);
    });

  const getCroppedImage = async () => {
    const image = await createImage(preview)
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')

    const width = WIDTH
    const height = HEIGHT
    canvas.width = width
    canvas.height = height

    // background ขาว
    ctx.fillStyle = 'white'
    ctx.fillRect(0, 0, width, height)

    const { x, y, width: cropWidth, height: cropHeight } = croppedAreaPixels

    ctx.drawImage(
      image,
      x,
      y,
      cropWidth,
      cropHeight,
      0,
      0,
      width,
      height
    )

    const imageBlob = await new Promise((resolve) => {
      canvas.toBlob((blob) => {
        resolve(blob)
      }, 'image/png', 0.85)
    })

    onComplete(imageBlob)
  }

  const onResetButtonClick = () => {
    setZoom(DEFAULT_ZOOM)
    setCrop({ x: 0, y: 0 })
  }

  useEffect(() => {
    if (!imageSrc) return

    const loadAndFit = async () => {
      const img = await createImage(imageSrc)

      const previewCanvas = document.createElement('canvas')
      const ctxPrev = previewCanvas.getContext('2d')
      const prevW = WIDTH
      const prevH = HEIGHT
      previewCanvas.width = prevW
      previewCanvas.height = prevH

      ctxPrev.fillStyle = 'white'
      ctxPrev.fillRect(0, 0, prevW, prevH)

      let scalePrev = Math.min(prevW / img.width, prevH / img.height)
      let newWPrev = img.width * scalePrev
      let newHPrev = img.height * scalePrev
      let offsetXPrev = (prevW - newWPrev) / 2
      let offsetYPrev = (prevH - newHPrev) / 2
      ctxPrev.drawImage(img, offsetXPrev, offsetYPrev, newWPrev, newHPrev)

      setPreview(previewCanvas.toDataURL('image/png', 0.9))
    }

    loadAndFit()
  }, [imageSrc])

  return (
    <>
      <Dialog
        open={open}
        onClose={onCancel}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          ปรับขนาดโลโก้ <CropIcon color="primary" classes="ml-2" />
        </DialogTitle>
        <DialogContent
          sx={{
            width: '100%',
            height: 500,
            position: 'relative',
          }}
        >
          <Cropper
            image={preview}
            aspect={WIDTH / HEIGHT}
            crop={crop}
            zoom={zoom}
            minZoom={0.5}
            restrictPosition={false}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
            style={{
              containerStyle: { width: '100%', height: '100%' },
              cropAreaStyle: { borderRadius: 4 },
            }}
          />
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'space-between' }}>
          <Button onClick={onResetButtonClick}>
            Fit
          </Button>
          <div>
            <Button autoFocus onClick={getCroppedImage}>
              ยืนยัน
            </Button>

            <Button color="error" onClick={onCancel}>
              ยกเลิก
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default CropModal
